var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89609 16.8348H16.1039C17.6988 16.8348 18.5 15.8981 18.5 14.0424V3.04239C18.5 1.18669 17.6988 0.25 16.1039 0.25H2.89609C1.30901 0.250384 0.5 1.17823 0.5 3.04239V14.0428C0.5 15.9073 1.30901 16.8348 2.89609 16.8348ZM1.72865 3.11541C1.72865 2.17834 2.15578 1.70096 2.91888 1.70096H8.96218V5.41274H1.72832L1.72865 3.11541ZM10.0378 5.41274V1.70096H16.0811C16.8364 1.70096 17.2714 2.17834 17.2714 3.11541V5.41274H10.0378ZM10.0378 10.4033V6.68267H17.2714V10.4033H10.0378ZM8.96218 6.68267V10.4033H1.72832V6.68267H8.96218ZM16.0811 15.3842H10.0378V11.6732H17.2714V13.9702C17.2714 14.9072 16.8364 15.3842 16.0811 15.3842ZM2.91888 15.3846C2.15578 15.3846 1.72865 14.9076 1.72865 13.9706V11.6732H8.96218V15.385L2.91888 15.3846Z",
    fill: "#F4F8FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.3fa6f817.svg";
export { ForwardRef as ReactComponent };